// hooks/useCategories.js - ACTUALIZADO CON AUTOCOMPLETE
import { useState, useCallback } from 'react';
import { groceriesApi } from '../api/groceriesApi';
import i18n from '../i18n';

export const useCategories = (showToast) => {
  const [availableCategories, setAvailableCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCategories = useCallback(async () => {
    try {
      setLoading(true);
      const data = await groceriesApi.fetchCategories();
      
      if (data.success) {
        const categoriesFromAPI = data.categories || [];
        
        // Siempre incluir 'others' si no está presente
        const allCategories = [...categoriesFromAPI];
        if (!allCategories.includes('others')) {
          allCategories.push('others');
        }
        
        setAvailableCategories(allCategories);
        setError(null);
      } else {
        throw new Error(data.message || 'Failed to load categories');
      }
    } catch (err) {
      setError(i18n.t('toasts.errorLoadingCategories', { msg: err.message }));
      if (showToast) showToast(i18n.t('toasts.errorLoadingCategories', { msg: err.message }), 'error');
      setAvailableCategories(['others']);
    } finally {
      setLoading(false);
    }
  }, [showToast]);

  const updateCategories = useCallback((newItem) => {
    if (newItem.category && !availableCategories.includes(newItem.category)) {
      setAvailableCategories(prev => [...prev, newItem.category]);
    }
  }, [availableCategories]);

  const addNewCategory = useCallback((categoryName) => {
    const normalizedCategory = categoryName.trim();
    if (!normalizedCategory) return;
    
    if (!availableCategories.includes(normalizedCategory)) {
      setAvailableCategories(prev => [...prev, normalizedCategory]);
    }
  }, [availableCategories]);

  const filterCategories = useCallback((searchTerm) => {
    if (!searchTerm.trim()) {
      return availableCategories;
    }
    
    const term = searchTerm.toLowerCase().trim();
    return availableCategories.filter(category => 
      category.toLowerCase().includes(term)
    );
  }, [availableCategories]);

  const formatCategory = useCallback((category) => {
    if (!category) return '';
    return category.charAt(0).toUpperCase() + category.slice(1).toLowerCase();
  }, []);

  return {
    availableCategories,
    loading,
    error,
    fetchCategories,
    updateCategories,
    addNewCategory,
    filterCategories,
    formatCategory
  };
};